import React from "react";
import Map, { Marker, MapControls, Popup, MapConstant, MarkerLayer } from "../../../lib/Map";
import { ShipmentsMarker, TerminalMarker } from "../../../components/mapComponents/Markers";
import {  CustomerPopup, ZonePopUpInfo } from "../../../components/mapComponents/Popups";
import appConstant from "../../../appConstants";
import Events from"../../../utilities/EventEmitter";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withStyles, withTheme } from "@material-ui/core";
import StyledToolTip from "../../common/StyledToolTip";
import { withAppConfig } from "../../../appConfigContext";
import MarkLocation from "./MarkLocation";
import styles from "./styles";
import DrawStyles from "./../../../lib/Map/Trimble/components/DrawStyles";
import DrawingTools from "../Settings/common/DrawTools/DrawingTools";
import { observer, inject } from "mobx-react";
import drawConstant from "./../Settings/common/DrawTools/DrawConstant"
import CustomConfirmationDialog from "../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";
import { getDataWithQueryString, postData } from "../../../api/componentAPIs";
import { withSnackbar } from 'notistack';
import { API_STATUS_MSG, LOCATION_TAB } from "./MarkLocation/constants";
import { getExistingFeaturesGeoJSON } from "./MarkLocation/utils";

@inject("CommonStore")
@observer
class CustomerMap extends React.Component {
    constructor(props) {
        super(props);
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location; 
        this.state = {
            zoneInfo: null,
            selectedCustomer: null,
            selectedCustomerList: [],
            gridSelectedCustomers: [],
            markLocation: false,
            customerLocationMappingData: [],
            selectedLocationMapper: {},
            geoDataList: [],
            dowGeoDataList: [],
            activeLocationTab: LOCATION_TAB.EQUIPMENT,
            isLocationConfirmationDialogOpen: false,
            isDataLoaded: false,
            isLocationDeleteInProgress: false,
        }
        this.mapId = appConstant.mapIds.CUSTOMER_MAP;
        this.mapRef = React.createRef();
    }

    componentDidMount(){
      this.props.glEventHub.on("CustomerLocationMapping", this.onToggleCustomerLocation);
      this.props.glEventHub.on(`customerSelectedonGrid`,this.onGridCustomerSelected);
    }

    componentWillUnmount(){
      this.props.glEventHub.off("CustomerLocationMapping", this.onToggleCustomerLocation);
      this.props.glEventHub.off(`customerSelectedonGrid`,this.onGridCustomerSelected);
    }

    handleLocationTabChange = (tabIndex) => {
      this.setState({ activeLocationTab: tabIndex });
    }

    onToggleCustomerLocation = (markLocation) => {
      if (markLocation) {
        this.getLocationMappingData();
        this.mapRef.current.classList.add('locationMappingMapContainer');
      } else {
        this.mapRef.current.classList.remove('locationMappingMapContainer');
        this.props.glEventHub.emit("mapResize");
      }
      this.setState({
        customerLocationMappingData: [],
        markLocation,
        isDataLoaded: false,
        geoDataList: [],
        dowGeoDataList: [],
        activeLocationTab: LOCATION_TAB.EQUIPMENT,
      })
    }

    getLocationMappingData = (initialLoad= false) => {
      !initialLoad && this.setState({isDataLoaded: false});
      getDataWithQueryString(
        "CustomerLocationMapping",
        `terminalId=${this.props.userData.userProfile.terminal.id}`
      ).then((response) => {
        if (response?.status >= 200 && response?.status < 400) {
          const formattedData = this.getFormattedData(response.data);
          this.setState({
            customerLocationMappingData: formattedData,
            geoDataList: getExistingFeaturesGeoJSON(formattedData),
            isDataLoaded: true,
            isLocationDeleteInProgress: false,
          });
        } else {
          this.setState({
            isDataLoaded: true,
            isLocationDeleteInProgress: false,
          });
          this.props.enqueueSnackbar(API_STATUS_MSG.FETCH_FAILED, {
            variant: "error",
          });
        }
      });
    };

    updateDowGeoDataList = (dowGeoData) => {
      this.setState({ dowGeoDataList: dowGeoData });
    };

    getFormattedData = (data) => {
      return data
        .map((locationMapping) => {
          return {
            ...locationMapping,
            boundary: JSON.parse(locationMapping.boundary),
          };
        })
        .sort((a, b) => (a.locationMappingId < b.locationMappingId ? 1 : -1));
    };
    
    onMapClicked = () => {
        this.hideAllPopups();
    }

    onZoneClicked = (zoneInfo) => {
      this.setState({ zoneInfo });
    };

    onTerminalClicked = ({ marker }) => {
        this.setState({
            selectedCustomer: null,
        })
    }

    onGridCustomerSelected = (gridSelectedCustomers) => {
      const selectedCustomers = gridSelectedCustomers.slice(0, 500); // Get Top 500 markers , Rendering large number of markers degrade app performance as well as dont provide much insight to user
      const selectedCustomerCodes = selectedCustomers.map(customer => customer.code);
      this.setState((prevState) => ({
        gridSelectedCustomers: selectedCustomers,
        selectedCustomerList: selectedCustomerCodes,
        selectedCustomer: selectedCustomerCodes.includes(
          prevState.selectedCustomer?.code
        )
          ? prevState.selectedCustomer
          : null,
      }));
    };
    onCustomerMarkerClicked = (customer) => {
      const customerAlreadySelected = this.state.selectedCustomerList.includes(customer.code);
      const updatedSelectedCustomers = customerAlreadySelected ? this.state.selectedCustomerList : [customer.code];
      
      this.setState({
        selectedCustomer: customer,
        selectedCustomerList: updatedSelectedCustomers,
      });
    }

    
    hideAllPopups = () => {
        this.setState({
            selectedCustomer: null,
            zoneInfo: null,
        });
    }

    onScaleDrawingComplete = (feature, type) => {
      if ([MapConstant.DRAWING_EVENTS.CREATE, MapConstant.DRAWING_EVENTS.UPDATE].includes(type)) {
        Events.emit(`${this.mapId}_${drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_UPDATED}`, feature);
      }
    };

    isCustomerActive = (code) => {
       return this.state.selectedCustomerList.includes(code);
    }

    getCustomerIcon = (customer) => {
      const isActive = this.isCustomerActive(customer.code);
      return (
        <StyledToolTip title={customer.name}>
          <div>
            <ShipmentsMarker
              dimension={isActive ? "35px" : "23px"}
              gradientPrimaryColor={this.props.theme.gradientPrimaryColor}
              gradientSecondaryColor={this.props.theme.gradientSecondaryColor}
              backgroundColor={
                isActive
                  ? this.props.theme.commonAppHeaderTabColor
                  : null
              }
            />
          </div>
        </StyledToolTip>
      );
    }

    getMarkerLayerCenter = () => {
      const { selectedCustomer, gridSelectedCustomers, selectedCustomerList } = this.state;
      if (selectedCustomer?.latitude && selectedCustomer?.longitude) {
        return { lat: selectedCustomer.latitude, lng: selectedCustomer.longitude };
      } else if (selectedCustomerList.length === 1) {
        const selCustomer = gridSelectedCustomers.find(customer => selectedCustomerList.includes(customer.code));
        if (selCustomer?.latitude && selCustomer?.longitude) {
          return { lat: selCustomer.latitude, lng: selCustomer.longitude };
        }
      }
      return null;
    }

    onCancelLocationClick = () => {
      Events.emit(
        `${this.mapId}_${drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP}`,
        "cancel",
        true
      );
      this.setState({
        selectedLocationMapper: {},
        isLocationConfirmationDialogOpen: false,
      });
    };

    closeDeletePopup = () => {
      this.setState({
        isLocationConfirmationDialogOpen: false,
        isLocationDeleteInProgress: true,
      })
    }

    onDeleteLocationClick = () => {
      const request = {
        terminalId: this.props.userData.userProfile.terminal.id,
        locationMappingId: this.state.selectedLocationMapper.locationMappingId,
      };
      this.closeDeletePopup();
      postData("DeleteCustomerLocationMapping", request).then(
        (response) => {
          if (response?.status >= 200 && response?.status < 400) {
            Events.emit(`${this.mapId}_${drawConstant.ROUTE_MAPPING_EVENTS.CLOSE_FORM}`, true);
            this.getLocationMappingData();
            this.props.enqueueSnackbar(
              API_STATUS_MSG.DELETE_SUCCESS,
              {
                variant: "success",
              }
            );
            this.setState({isLocationDeleteInProgress: false})
            this.props.glEventHub.emit('RefreshCustomerData');
            return;
          }
          this.handleError(response.status);
        },
        () => {
          this.handleError();
        }
      );
    };

    handleError = (statusCode) => {
      this.setState({isLocationDeleteInProgress: false})
      if (statusCode === 403) {
        return;
      }
      this.props.enqueueSnackbar(API_STATUS_MSG.DELETE_FAILED, {
        variant: "error",
      });
    };
  
    onDeleteLocation = (card) => {
      this.setState({
        selectedLocationMapper: card,
        isLocationConfirmationDialogOpen: true,
      });
    };

    render() {
        const { theme, classes } = this.props;
        const container = this.props.glContainer.parent.parent.element[0];
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
        return (
          <div className="customerMapContainer" ref={this.mapRef}>
            <Map
              zoom={11}
              initialCenter={this.terminalLocation}
              onClick={this.onMapClicked}
              mapId={this.mapId}
              mapTheme={theme.themeName}
              center={this.terminalLocation}
              eventHub={this.props.glEventHub}
              mapConfig={this.props.configJSON?.maps}
            >
              <MapControls
                controlOptions={{
                  zoomControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  satelliteViewControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  reCenterMapControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  showZones: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                    terminalID: this.props.userData.userProfile.terminal.code,
                    onZoneClicked: this.onZoneClicked,
                    geoJson: this.props.userData.userProfile?.geoJson
                  },
                }}
              />

              <Marker
                position={this.terminalLocation}
                onClick={this.onTerminalClicked}
                animation
                // anchor point is the point in the image which should overlap the location,
                // Terminal image is of different size than the marker so we can override the default value as shown below
                anchorPoint={{ x: 20, y: 20 }}
                zIndex={1}
                forceUpdate={true}
                isActiveShipment={true}
              >
                <TerminalMarker
                  data={this.props.userData.userProfile.terminal}
                  color={theme.terminalContentColor}
                />
              </Marker>
              <MarkerLayer
                code={this.props.userData.userProfile.terminal.code}
                data={this.state.gridSelectedCustomers
                  .filter(customer => customer.latitude && customer.longitude)
                  .slice()}
                dataKey={"code"}
                activeMarkerIds={this.state.selectedCustomerList.slice()}
                getIcon={this.getCustomerIcon}
                center={this.getMarkerLayerCenter()}
                onClick={this.onCustomerMarkerClicked}
                showTooltip
              />

              <DrawingTools
                singleColorDraw={true}
                polygonOptions={{
                  fillColor: theme.MapDrawingColor,
                  strokeColor: theme.MapDrawingColor,
                }}
                geoDataList={this.state.activeLocationTab === LOCATION_TAB.EQUIPMENT ? this.state.geoDataList : this.state.dowGeoDataList}
                styleArray={DrawStyles(theme.commonAppHeaderTabColor)}
                eventHub={Events}
                onDrawingComplete={this.onScaleDrawingComplete}
                useMapIdWithEvent
              />

              {this.state.selectedCustomer && this.state.selectedCustomer.latitude && this.state.selectedCustomer.longitude && (
                <Popup
                  // forceRender will rerender the child component into the infowindow,
                  // set to true when theme changes or data is updated for selected customer
                  position={{ lat: this.state.selectedCustomer.latitude, lng: this.state.selectedCustomer.longitude }}
                  forceRender={this.state.themeChanged}
                  key={`${this.state.selectedCustomer.code}_customerPopup`}
                >
                  <CustomerPopup
                    data={this.state.selectedCustomer}
                    theme={this.props.theme.themeName}
                  />
                </Popup>
              )}
              {this.state.zoneInfo && (
                <Popup isCloseButton position={this.state.zoneInfo.position}>
                  <ZonePopUpInfo data={this.state.zoneInfo.data} />
                </Popup>
              )}
            </Map>
            {this.state.markLocation && (
              <MarkLocation
                open
                variant="persistent"
                ModalProps={container ? { container } : {}}
                drawerClasses={{
                  paper: classes.paperAnchor
                }}
                equipmentSizeList={this.props.CommonStore.equipmentSizes}
                customerLocationMappingData={this.state.customerLocationMappingData}
                getLocationMappingData={this.getLocationMappingData}
                isLocationDeleteInProgress={this.state.isLocationDeleteInProgress}
                isDataLoaded={this.state.isDataLoaded}
                onDeleteLocation={this.onDeleteLocation}
                terminalId= {this.props.userData.userProfile.terminal.id}
                geoDataList={this.state.geoDataList}
                dowGeoDataList={this.state.dowGeoDataList}
                updateDowGeoDataList={this.updateDowGeoDataList}
                onTabChange={this.handleLocationTabChange}
                activeLocationTab={this.state.activeLocationTab}
                glEventHub={this.props.glEventHub}
                mapId={this.mapId}
              />
            )}
            {this.state.isLocationConfirmationDialogOpen && (
              <CustomConfirmationDialog
                title="Delete Selected Region"
                cancelButtonLabel="Cancel"
                confirmButtonLabel="Delete"
                mode="danger"
                onConfirm={this.onDeleteLocationClick}
                onCancel={this.onCancelLocationClick}>
                Are you sure you want to delete {this.state.selectedLocationMapper.locationName} customer location?
              </CustomConfirmationDialog>
            )}
          </div>
        );
    }
}
export default compose(
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withAppConfig
)(CustomerMap);
